const translations = {
  "en": {
    "Ask Ed": "Ask Ed",
    "Ed will need a recharge soon...": "Ed will need a recharge soon...",
    "Meet Ed": "Meet Ed",
    "Renew": "Renew",
    "What's on your mind?": "What's on your mind?"
  },
  "zh-tw": {
    "Ask Ed": "問 Ed",
    "Ed will need a recharge soon...": "Ed 很快需要充電了……",
    "Meet Ed": "認識 Ed",
    "Renew": "續訂",
    "What's on your mind?": "你在想什麼？"
  }
};

export default translations;
